import { OptionList } from '../../../app-layer/util/typings'

const getCurrentSelectedOptionsFromFields = (
  fields:
    | NodeListOf<HTMLSelectElement | HTMLInputElement>
    | HTMLInputElement[]
    | HTMLSelectElement[]
): OptionList => {
  if (fields.length > 3) {
    console.info('Too many option fields rendered')
  }
  return Array.from(fields)
    .slice(0, 3)
    .map((field) => field.value) as OptionList
}

export default getCurrentSelectedOptionsFromFields
